///<reference path="../students/components/add-student/add-student.component.ts"/>
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { DivisionService } from '../../../../services/divisions/division.service';
import { LightboxModule } from 'ngx-lightbox';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { SchoolyearComponent } from './schoolyear.component';
import { SchoolYearService } from '../../../../services/schoool-year/school-year.service';
import { AddEditSchoolYearModule } from './add-edit-school-year/add-edit-school-year.module';

const routes = [
    {
        path: 'pages/management/schoolyear',
        component: SchoolyearComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_SCHOOL_YEAR',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        SchoolyearComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        LightboxModule,
        AddEditSchoolYearModule
    ],
    exports: [
        SchoolyearComponent
    ],
    entryComponents: [],
    providers: [
        SchoolYearService,
        DivisionService
    ]
})

export class FuseSchoolYearModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/schoolyear/schoolyear.module.ts